var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"w_cal_btn",on:{"click":_vm.isEdit}},[_c('a',{on:{"click":_vm.Write}})])
}
var staticRenderFns = []

export { render, staticRenderFns }